// import Seo from "../global/Seo";

const PrivacyPolicy = () => {
  return (
    <>
      {/* <Seo data={objSeo} /> */}

      <div id="privacy-policy" className="container">
        <h1 className="wise-secondary-gradient">PRIVACY POLICY</h1>
        <br />

        <p className="text-secondary">
          <strong>[Women in Semiconductor Ecosystem]</strong>
          (the "Women in Semiconductor Ecosystem") is committed to protecting
          the privacy of its users, members, and event participants. This
          Privacy Policy (“Privacy Policy”) is designed to help you understand
          what information we collect, how we use it, how we protect it, and to
          assist you in making informed decisions when using our website.
        </p>

        <p className="text-secondary">
          This Privacy Policy applies to our website, community portals, event
          registration pages, payment systems, and any data collected through
          partnered or unaffiliated platforms that reference this Privacy
          Policy.
        </p>

        <p className="text-secondary">
          For purposes of this Agreement, the terms “we,” “us,” and “our” refer
          to the Company. “You” refers to any user, visitor, member, or event
          participant accessing the website.
        </p>

        <h4 className="wise-secondary-gradient">I. CONSENT</h4>
        <p className="text-secondary">
          By accessing or using our website, registering for events, creating an
          account, or completing payments, you accept this Privacy Policy and
          our Terms of Use. You consent to the collection, storage, use, and
          disclosure of your personal information as described in this Privacy
          Policy.
        </p>

        <p className="text-secondary">
          This Privacy Policy applies whether or not you register, log in, or
          complete a transaction on the website.
        </p>

        <h4 className="wise-secondary-gradient">II. INFORMATION WE COLLECT</h4>
        <p className="text-secondary">
          We may collect both “Non-Personal Information” and “Personal
          Information.”
        </p>

        <p className="text-secondary">
          <strong>Personal Information</strong> includes information that can
          identify you, such as:
        </p>

        <ul className="text-secondary">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Residential or mailing address</li>
          <li>Professional details (organization, role, experience)</li>
          <li>Event registration details</li>
          <li>Payment reference details</li>
        </ul>

        <p className="text-secondary">
          <strong>Non-Personal Information</strong> includes anonymized data
          such as browser type, device information, referring URLs, pages
          visited, and interaction patterns.
        </p>

        <h3 className="wise-secondary-gradient">Google Analytics</h3>
        <p className="text-secondary">
          We use Google Analytics to collect anonymized information regarding
          website usage. This includes browser type, device information, date
          and time of access, and pages visited. This data helps us improve
          website performance and user experience.
        </p>

        <h3 className="wise-secondary-gradient">Cookies</h3>
        <p className="text-secondary">
          Cookies are small text files stored on your device that help us
          recognize user preferences and analyze website traffic. You may
          disable cookies through your browser settings, though some features of
          the website may not function correctly.
        </p>

        <h3 className="wise-secondary-gradient">
          Website Forms & Event Registrations
        </h3>
        <p className="text-secondary">
          Our website includes forms for community membership, mentorship
          programs, workshops, conferences, and other events. When you submit a
          form, we may collect your name, email address, phone number, address,
          and professional information.
        </p>

        <p className="text-secondary">
          This information is used solely for managing registrations,
          communication, participation, and internal reporting. We do not sell
          or misuse this information.
        </p>

        <h4 className="wise-secondary-gradient">Payments & Login (Razorpay)</h4>
        <p className="text-secondary">
          We use Razorpay for secure payment processing related to event
          registrations and memberships. The Company does not store your card,
          UPI, or banking details.
        </p>

        <p className="text-secondary">
          Payment information is processed directly by Razorpay in accordance
          with their privacy and security policies. Limited transaction details
          such as payment status and reference IDs may be stored for records,
          invoicing, and support purposes.
        </p>

        <h4 className="wise-secondary-gradient">Social Media</h4>
        <p className="text-secondary">
          We maintain a presence on social media platforms such as LinkedIn,
          Instagram, WhatsApp, and others. We may collect information when you
          interact with our official pages or communications.
        </p>

        <h4 className="wise-secondary-gradient">
          III. HOW WE USE AND SHARE INFORMATION
        </h4>
        <ul className="text-secondary">
          <li>Managing user accounts and event participation</li>
          <li>Processing payments and registrations</li>
          <li>Communicating updates, confirmations, and announcements</li>
          <li>Improving website content and user experience</li>
          <li>Ensuring platform security and fraud prevention</li>
          <li>Legal and regulatory compliance</li>
        </ul>

        <h4 className="wise-secondary-gradient">Personal Information</h4>
        <p className="text-secondary">
          We do not sell, rent, or trade your Personal Information. We may share
          it with trusted third-party service providers such as payment
          processors, hosting services, and communication platforms, strictly
          for operational purposes.
        </p>

        <h4 className="wise-secondary-gradient">
          IV. HOW WE PROTECT INFORMATION
        </h4>
        <p className="text-secondary">
          We implement reasonable technical and organizational safeguards to
          protect your information. While we follow industry best practices, no
          system can guarantee absolute security.
        </p>

        <h4 className="wise-secondary-gradient">V. YOUR RIGHTS</h4>
        <p className="text-secondary">
          You have the right to access, correct, or request deletion of your
          personal data, subject to legal obligations. You may withdraw consent
          for communications at any time by contacting us.
        </p>

        <h4 className="wise-secondary-gradient">VI. HOSTING</h4>
        <p className="text-secondary">
          Our website is hosted by a third-party hosting provider. Your data may
          be stored on secure servers managed in compliance with applicable data
          protection laws.
        </p>

        <h4 className="wise-secondary-gradient">
          VII. LINKS TO OTHER WEBSITES
        </h4>
        <p className="text-secondary">
          We are not responsible for the privacy practices of third-party
          websites linked from our platform. Please review their policies
          independently.
        </p>

        <h4 className="wise-secondary-gradient">VIII. AGE OF CONSENT</h4>
        <p className="text-secondary">
          By using this website, you confirm that you are at least 18 years of
          age.
        </p>

        <h4 className="wise-secondary-gradient">
          IX. CHANGES TO THIS PRIVACY POLICY
        </h4>
        <p className="text-secondary">
          We reserve the right to update this Privacy Policy at any time. Any
          changes will be posted on this page and become effective upon
          continued use of the website.
        </p>

        <h4 className="wise-secondary-gradient">X. MERGER OR ACQUISITION</h4>
        <p className="text-secondary">
          In the event of a merger, acquisition, or asset transfer, your
          information may be transferred as part of that transaction.
        </p>

        <h4 className="wise-secondary-gradient">
          XI. CONTACT US & WITHDRAWING CONSENT
        </h4>
        <p className="text-secondary">
          If you have any questions about this Privacy Policy or wish to
          withdraw consent, please contact us at:
        </p>

        <p className="text-secondary">
          <strong>Email:</strong> info@wise-semicon.com
        </p>

        <h4 className="wise-secondary-gradient">XII. LAST UPDATED</h4>
        <p className="text-secondary">
          This Privacy Policy was last updated on Tuesday, Feb 17, 2026.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
